import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState, useEffect } from 'react';
import { PopupHeader, CloseModalLink, Container, ValidateCodeActionButton, ValidateCodeDescription, ValidateCodeError, ValidateCodeFooter, ValidateCodeLink } from '../styles';
import { texts } from '../../config/texts';
import { PasswordInput } from '../passwordInput/PasswordInput';
import ValidateCodeIcon from '../../icons/ValidateCodeIcon';
import { clickstreamViewEvent, interactionRioEvent } from '../../lib/rio';
import { Step } from '../webMfa/WebMfa.types';
var ValidateCode = function ValidateCode(props) {
  var validateCodeText = texts.validateCodeText,
    errorMessages = texts.errorMessages;
  var email = props.email,
    isLoading = props.isLoading,
    clearError = props.clearError,
    onModalClose = props.onModalClose,
    validateCode = props.validateCode,
    errorMessage = props.errorMessage,
    returnToSendEmailStep = props.returnToSendEmailStep;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    code = _useState2[0],
    setCode = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    disableButton = _useState4[0],
    setButtonDisableState = _useState4[1];
  useEffect(function () {
    clickstreamViewEvent(Step.ValidateCode);
  }, []);
  var onInputChange = function onInputChange(val) {
    clearError();
    setCode(val);
    setButtonDisableState(val.length != 6 || !val.match(/^[0-9]*$/));
  };
  var cleanComponentAndReturn = useCallback(function () {
    setCode('');
    returnToSendEmailStep();
  }, [returnToSendEmailStep]);
  var onSubmit = useCallback(function (e) {
    e.preventDefault();
    interactionRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'button',
          name: 'submitted mfa code',
          region_name: 'mfa validate code modal',
          text: texts.validateCodeText.buttonText
        }
      }
    });
    clearError();
    setCode('');
    setButtonDisableState(true);
    validateCode(code);
  }, [clearError, code, validateCode]);
  var closeModal = useCallback(function () {
    onModalClose();
  }, [onModalClose]);
  var renderCloseModalLink = function renderCloseModalLink(error) {
    if (error === errorMessages.expired_token) {
      return /*#__PURE__*/React.createElement(CloseModalLink, {
        "data-test": "mfa_return_to_signin_link",
        onClick: closeModal
      }, errorMessages.start_over_link_text);
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    id: 'validateCodeDialog',
    "data-test": "validate-code-dialog",
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ValidateCodeIcon, null), /*#__PURE__*/React.createElement(PopupHeader, {
    "data-test": "validation_code_header"
  }, validateCodeText.header), /*#__PURE__*/React.createElement(ValidateCodeDescription, null, validateCodeText.description, " ", email), /*#__PURE__*/React.createElement(PasswordInput, {
    inputId: "password_input",
    "data-test": 'validation_input',
    "aria-label": 'validationCodeHeader',
    labelText: '',
    value: code,
    onChange: onInputChange,
    className: 'validateCodeInput',
    hasErrors: errorMessage !== '',
    hideButton: true
  }), errorMessage && /*#__PURE__*/React.createElement(ValidateCodeError, {
    "data-test": "validate_code_error"
  }, errorMessage, renderCloseModalLink(errorMessage)), /*#__PURE__*/React.createElement(ValidateCodeActionButton, {
    type: "submit",
    size: "large",
    disabled: disableButton,
    "data-test": "validate_code_button",
    isLoading: isLoading
  }, validateCodeText.buttonText), /*#__PURE__*/React.createElement(ValidateCodeFooter, {
    id: "validateCodeFooterContent"
  }, validateCodeText.footer, ' ', /*#__PURE__*/React.createElement(ValidateCodeLink, {
    "data-test": "validate_code_link",
    onClick: cleanComponentAndReturn
  }, validateCodeText.footerSendAgain))));
};
export default ValidateCode;